import * as t from 'io-ts';
import { string } from 'yargs';
import {
  Template,
  MySafetyHtmls,
  OtherCityData,
  TopRoutes,
  CityToken,
  Offer,
  CabRentalPrice,
  CabTypesAvailableForRent,
  RouteInfo,
  LeaveIntentOffer,
  HotelsInfoType,
  RouteCarTypeInfo,
  InterlinkBlockDataChecker,
  AggregateRating,
  PackageDataChecker
} from '../../../src/pages/runtime-typechecker';
import { CouponData } from '../RouteTemplate/RouteDataTypeChecker';

export const NearbyCities = t.type({
  name: t.union([t.string, t.null, t.undefined]),
  url: t.union([t.string, t.null, t.undefined])
});

export const NameUrl = t.type({
  name: t.union([t.string, t.null, t.undefined]),
  url: t.union([t.string, t.null, t.undefined])
});

export const CityTemplateChecker = t.type({
  packages: t.union([t.array(PackageDataChecker), t.undefined]),
  id: t.number,
  created: t.string,
  modified: t.string,
  name: t.string,
  description: t.union([t.null, t.string, t.undefined]),
  description2HTML: t.union([t.null, t.string, t.undefined]),
  latitude: t.union([t.string, t.null]),
  longitude: t.union([t.string, t.null]),
  isActive: t.boolean,
  isAirport: t.boolean,
  htmlRefreshDate: t.union([t.string, t.null]),
  url: t.string,
  code: t.string,
  placeId: t.union([t.string, t.null]),
  overrideTemplate: t.union([t.null, t.undefined]),
  cityTokens: t.array(CityToken),
  offers: t.array(Offer),
  topRoutesfromCity: TopRoutes,
  topRoutesToCity: TopRoutes,
  cabTypesAvailableForRent: CabTypesAvailableForRent,
  cabRentalPrices: t.array(CabRentalPrice),
  templateData: Template,
  otherCitiesData: t.union([t.undefined, t.array(OtherCityData)]),
  status: t.string,
  mySafetyHtmls: t.union([t.undefined, MySafetyHtmls]),
  nearbyCities: t.union([t.array(NearbyCities), t.undefined]),
  routesFromSourceCity: t.union([t.array(RouteInfo), t.undefined]),
  routesToSourceCity: t.union([t.array(RouteInfo), t.undefined]),
  airportCabs: t.union([t.array(NameUrl), t.undefined]),
  routeCarTypeRoutesFromSource: t.array(RouteCarTypeInfo),
  leaveIntentOffers: t.union([t.array(LeaveIntentOffer), t.undefined]),
  hrPackages: t.union([t.array(t.string), t.undefined]),
  interlinks: t.union([t.undefined, t.array(InterlinkBlockDataChecker)]),
  hotelsAvailableInCity: t.union([
    t.array(HotelsInfoType),
    t.undefined,
    t.null
  ]),
  holidayPackagesInCity: t.union([
    t.array(HotelsInfoType),
    t.undefined,
    t.null
  ]),
  showTripAssistantButton: t.boolean,
  showTripAssistantButtonForDweb: t.boolean,
  assistedFormOpenDelay: t.number,
  showWhatsappWidget: t.boolean,
  showCallUsWidget: t.boolean,
  whatsappWidgetDeeplink: t.string,
  customerCareNumber: t.string,
  assistantWidgetText: t.string,
  showWhatsAppForAssistedForm: t.boolean,
  showCallUsForAssistedForm: t.boolean,
  aggregateRating: AggregateRating,
  schemaMinFare: t.number,
  inboundCallText: t.union([t.string, t.undefined]),
  inboundCallNumber: t.union([t.string, t.undefined]),
  showInboundCallNumberInDesktop: t.boolean,
  showCallusModalMweb: t.boolean,
  callusModalOpenDelay: t.number,
  showInboundNumberOnAssistedForm: t.boolean,
  couponInfo: CouponData,
  showLeaveIntentForm: t.boolean,
  openDateWidget: t.boolean,
  openTripTypeAndThenDate: t.boolean,
  semCustomerCareNumber: t.string,
  semInboundCallNumber: t.union([t.string, t.undefined]),
  openTripType: t.boolean,
  packagesInfo: t.boolean,
  packageData: t.any,
  allowRoundtrip: t.boolean,
  whatsappTooltipText: t.string,
  tripAssistanceToolTipText: t.string,
  intentCaptureEnabled: t.union([t.string, t.undefined, t.null]),
  intentCaptureType: t.union([t.string, t.undefined, t.null])
});
export type CityTemplateData = t.TypeOf<typeof CityTemplateChecker>;
